import axios from "axios";

import { GROWTH_INSURANCE_API } from "@modules/common/constants";
/*
 * Fetch steady labs documents
 * */

export type FetchLabsResponse = {
  data: UploadedLab[];
};

export type UploadedLab = {
  url: string;
  uploadedAt: string;
  title: string;
};

export const fetchSteadyLabs = async (
  userId: string,
  accessToken: string
): Promise<FetchLabsResponse> => {
  return (
    await axios.get<FetchLabsResponse>(
      `${GROWTH_INSURANCE_API}/v1/patient/${userId}/labs/`,
      {
        headers: {
          Authorization: `bearer ${accessToken}`,
        },
      }
    )
  ).data;
};
